/**
 * @module SAH
 * @param  {Object} $ jQuery-Objekt
 * @return {Null}
 */
(function($, Drupal, once) {
    'use strict';

    Drupal.behaviors.ScrollDownSmoth = {
        attach: function (context, settings) {
            var duration = 700;
            $('a[href^="#"], a[href^="/#"]', context).click(function() {
                // Hide menu on mobile
                $('body').removeClass('show-burger-menu');
                if ($(this.hash).length) {
                    scrollTo( this.hash );
                    return false;
                }
            });

            if (location.hash && $(location.hash).length) {
                let hash = location.hash;
                location.hash = '';
                scrollTo( hash, 200 );
            }

            function scrollTo(hash, delay) {
                $('html, body').delay(delay).animate({
                    scrollTop: $(hash).offset().top
                }, duration, function() {
                    // window.location.hash = hash.replace('#','');
                });
            }

        }
    };

    Drupal.behaviors.MessagesCloseBtn = {
        attach: function (context, settings) {
            $(once('statusMsgX', '#status-messages > div[role="contentinfo"]', context)).each(function (index) {
                var msg = $(this);
                $('<span>').addClass('close-btn').click(function () {
                    msg.remove();
                }).appendTo(msg);
            });
        }
    };

    Drupal.behaviors.ShowBurgerNavi = {
        attach: function (context, settings) {
            $('.menu-burger-icon').click(function() {
                $('body').toggleClass('show-burger-menu');
            });
        }
    };

    Drupal.behaviors.FAQitems = {
        attach: function (context) {
            $(once('faqShow', '.block-faq .faq-item', context)).each(function (i) {
                var item = $(this);

                if (i > 0) item.addClass('hide').find('.field-text').hide();

                item.find('.field-headline').on('touch click', function() {
                    $(this).parent()
                        .toggleClass('hide')
                        .find('.field-text')
                        .slideToggle('.3s');
                });
            });
        }
    };

    Drupal.behaviors.coursePartHideVideoModal = {
        attach: function (context, settings) {
            $('.course-video .hide-course-video', context).on('click', function () {
                $('body').removeClass('fixed');
                var wrapper = $(this).parents('.course-video');
                wrapper.removeClass('visible');
                wrapper.removeClass('ready');
                setTimeout(function(){
                    wrapper.find('#course-part-video').html('');
                }, 300);
            });
        }
    };

    Drupal.behaviors.showModalBlock = {
        attach: function (context, settings) {
            $('.modal-trigger', context).on('click', function () {
                var target = $(this).attr('data-target');
               $('#'+target).parent().fadeIn(500);
            });
        }
    };

    Drupal.behaviors.closeModalBlock = {
        attach: function (context, settings) {
            $('.close-modal', context).on('click', function () {
                var target = $(this).parents('.modal-block');
                $(target).fadeOut(500);
            });
        }
    };

    Drupal.behaviors.HideNavi = {
        attach: function (context, settings) {
            $(document).on('scroll', function(e){
                var st = $(this).scrollTop();
                if (st > 50) {
                    $('html').addClass('hide-navi');
                } else {
                    $('html').removeClass('hide-navi');
                }
            }).scroll();
        }
    };

    Drupal.behaviors.Cyberfitnessitems = {
        attach: function (context) {
            $('.block-cyberfitness .image-block', context).each(function (i) {
                var itemCyberImg = $(this);

                itemCyberImg.find('.field-code h1 span').on('touch click', function() {
                    var $temp = $("<input>");
                    $("body").append($temp);
                    $temp.val($(this).text()).select();
                    document.execCommand("copy");
                    $temp.remove();
                });
            });

            $('.block-cyberfitness .text-block', context).each(function (i) {
                var itemCyber = $(this);

                itemCyber.find('.toggle-items').on('touch click', function() {
                    $(this).prev()
                        .toggleClass('hide')
                        .find('.field-text')
                        .slideToggle('.3s');
                });
            });
        },
        // message: function message(ajax, response) {
        //     var messages = new Drupal.Message();
        //     var messageId = messages.add('Code:  copy');
        //
        //     messages.remove(messageId);
        // }
    };

    Drupal.behaviors.HideMessages = {
        attach: function (context, settings) {
            $(once('fadeOutStatus', '#status-messages', context)).delay(5000).fadeOut(1000);
        }
    };

    Drupal.behaviors.SetBlockSpaceHeight = {
        attach: function (context, settings) {
            $(once('setBlockSpaceHeight', '.block .container .space', context)).each(function (i) {
                var space = $(this);
                var container = space.parents('.container');
                space.width(container.height());
            });
        }
    };

    Drupal.behaviors.SetContactFormHeight = {
        attach: function (context, settings) {
            $(window).resize(function(){
                $('.block.contact-block', context).each(function (i) {
                    var contactBlockHeight = $(this).height();
                    var contactFormHeight = $('.contact-form', this).height();

                    var calculatedMargin = ((contactFormHeight - contactBlockHeight)) + 100;

                    if (calculatedMargin > 0) {
                        $(this).css( { marginTop : calculatedMargin + "px", marginBottom : calculatedMargin + "px" } );
                    } else {
                        $(this).css( { marginTop : "", marginBottom : "" } );
                    }
                });
            });

            $(window).trigger('resize');
        }
    };

    // Drupal.behaviors.ModifyUserCompanyFieldToSelect = {
    //     attach: function (context, settings) {
    //         $('#edit-field-company-wrapper input').once('status-messages-close').each(function (index) {
    //             var input = $(this).hide();
    //             var select = $('<select>').insertAfter(input);
    //
    //             $('<option>').attr('value', '_none').text('- Wert wählen -').appendTo(select);
    //             $('<option>').text('Kölner Verkehrs-Betriebe AG').appendTo(select);
    //             $('<option>').text('RheinEnergie AG').appendTo(select);
    //             $('<option>').text('Rheinische Netzgesellschaft mbH').appendTo(select);
    //             $('<option>').text('Abfallwirtschaftsbetriebe Köln GmbH & Co KG').appendTo(select);
    //             $('<option>').text('Häfen und Güterverkehr AG').appendTo(select);
    //             $('<option>').text('NetCologne Gesellschaft für Telekommunikation mbH').appendTo(select);
    //             $('<option>').text('BRUNATA Metrona GmbH').appendTo(select);
    //             $('<option>').text('Abfallentsorgungs- und Verwertungsgesellschaft Köln mbH').appendTo(select);
    //             $('<option>').text('KölnBäder GmbH').appendTo(select);
    //             $('<option>').text('AggerEnergie GmbH').appendTo(select);
    //             $('<option>').text('Stadtwerke Köln GmbH').appendTo(select);
    //             $('<option>').text('Gasversorgungsgesellschaft mbH Rhein-Erft').appendTo(select);
    //             $('<option>').text('Stadtentwässerungsbetriebe Köln, AöR').appendTo(select);
    //             $('<option>').text('moderne stadt').appendTo(select);
    //             $('<option>').text('Energieversorgung Dormagen GmbH').appendTo(select);
    //
    //             select.on('change', function () {
    //               var text = $(this).find( "option:selected" ).val();
    //               if (text !== '_none') {
    //                 input.attr('value', text);
    //               } else {
    //                 input.attr('value', '');
    //               }
    //             });
    //
    //             console.log(input);
    //         });
    //     }
    // };

    // var lastScrollTop = 0;
    // $(document).on( 'scroll', function(e){
    //     var st = $(this).scrollTop();
    //     if (st > lastScrollTop){
    //         $('html').addClass('scroll-down');
    //         $('html').removeClass('scroll-up');
    //     } else {
    //         $('html').removeClass('scroll-down');
    //         $('html').addClass('scroll-up');
    //     }
    //     lastScrollTop = st;
    // });


    // function shwoHiddenInfo(id) {
    //     $(id).on("click", function (){
    //         $('.content_block').slideToggle(300);
    //         return false;
    //     });
    // }

    //faq hide/show
    // function faq_callapse(el) {
    //     // $('.block-faq .paragraph-children > h2:not(:first-child)').addClass('collapsed');
    //     // $('.block-faq .paragraph-children > div').addClass('show');
    //     // $('.block-faq .paragraph-children > div ~ div').removeClass('show');
    //     // $('.block-faq .paragraph-children > div ~ div').slideUp("slow");

    //     $(el).on('change click', function() {

    //         $(this).toggleClass('show');
    //         var  height = $(this).find('.field-text').height();

    //     //     var id = $(this).attr('data-toggle');
    //     //     if ($(id).hasClass('show')) {
    //     //         $(this).addClass('collapsed');
    //     //         $(id).removeClass('show');
    //     //         $(id).slideUp("slow");
    //     //     } else {
    //     //         $(this).removeClass('collapsed');
    //     //         $(id).addClass('show');
    //     //         $(id).slideDown("slow");
    //     //     }
    //         console.log( height );
    //     });
    // }

    // ///////////////////////////////////
    // Check the checkbox status and update the "Select all" button for Magazine
    function updateSelectAllButtonStatus(checkboxes, button) {
        $(checkboxes).each(function() {
            if ($(this).prop('checked')) {
                button.removeClass('checked');
                return false; // Exit the loop early if any checkbox is not checked
            }

            button.addClass('checked');
        });
    }

    // Magazine filter for 'empty' options
    Drupal.behaviors.MagazineViewsBehavior = {
        attach: function (context, settings) {

            var checkboxes = $('#views-exposed-form-magazin-block-1 div[id^="edit-field-category-target-id"] .form-checkboxes.bef-checkboxes');
            if (checkboxes.length) {
                var getAll = Drupal.t('Select all');

                var link = $('<div class="form-item js-form-type-checkbox button--get-all checked"><label class="option" href="#">' + getAll + '</label></div>');
                link.click(function (event) {
                    event.preventDefault();
                    event.stopPropagation();


                    // Unselect all the checkboxes.
                    $(this)
                        .siblings(checkboxes)
                        .find('input:checkbox').each(function () {
                        $(this).prop('checked', false);
                    })
                        .end()
                        .find('input[type=checkbox]:first').change();
                });

                link.prependTo(checkboxes);


                var form_item = $(checkboxes).children('.form-item').find('input[type=checkbox]');
                var button = $(checkboxes).children('.form-item.button--get-all');
                updateSelectAllButtonStatus(form_item, button);
            }
        }
    };

    $(document).ready(function() {
        // faq_callapse('.block-faq .faq-item');
        // SAH.init();

        // var  mn = $("nav.region-menu");
        // var  mns = "nav-fixed-top navbar-bg-main-blue bg-main-blue";
        // var  hdr = $('#header').height();

        // $(window).scroll(function() {
        //     if( $(this).scrollTop() > (80) ) {
        //         mn.addClass(mns);
        //     } else {
        //         mn.removeClass(mns);
        //     }
        // });


        // $('.course-part .field-plugin-ico').click(function (){
        //     $(this).children('.course-part .field-plugin-ico-text').toggleClass('d-none');
        // });
    });

    // Im globalen Kontext bereitstellen
    // window.SAH = SAH;
})(jQuery, Drupal, once);

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR")
  });
}
